// Shared cache tag linking tour queries (meta.tags) to the mutations that invalidate them (meta.invalidates).
export const ZCALENDAR_TOURS_QUERY_TAG = 'zcalendar:tours';
